import { useOohRoutesQuery } from '../graphql/Routes/OohRoutes.generated';
import { OohRoute } from '../graphql/types';

type OohRoutesResult = {
  oohRoutes: OohRoute[];
  areOohRoutesLoading: boolean;
};

const useOohRoutesDataStore = (
  date: string | null,
  agencyId: string | null,
): OohRoutesResult => {
  const { loading, data } = useOohRoutesQuery({
    skip: !agencyId || !date,
    variables:
      agencyId && date
        ? {
            agencyId,
            date,
          }
        : undefined,
  });

  if (data !== undefined) {
    return {
      oohRoutes: data.OohRoutes,
      areOohRoutesLoading: loading,
    };
  }

  return {
    oohRoutes: [],
    areOohRoutesLoading: false,
  };
};

export default useOohRoutesDataStore;
